<template>
  <div ref="infiniteLoading" style="min-height: 1px">
    <div v-show="isLoading">
      <slot>
        <Spinner />
      </slot>
    </div>
  </div>
</template>
<script>
import Spinner from "@/components/base/BSpinner.vue";

export default {
  name: "InfiniteScrolling",
  components: {
    Spinner,
  },
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    firstLoad: {
      type: Boolean,
      default: true,
    },
    distance: {
      type: Number,
      default: 0,
    },
  },
  emits: ["bottom-reached", "top-reached", "scroll-down", "scroll-up"],
  data() {
    return {
      lastScrollTop: 0,
      isLoading: false,
    };
  },
  mounted() {
    this.$refs.infiniteLoading.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    this.$refs.infiniteLoading.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (this.isLoading) {
        return;
      }
      const element = this.$refs.infiniteLoading;
      const bottomOfElement = element.scrollHeight - element.scrollTop === element.clientHeight;
      const topOfElement = element.scrollTop === 0;
      const st = element.scrollTop;
      if (st > this.lastScrollTop) {
        this.$emit("scroll-down");
      } else {
        this.$emit("scroll-up");
      }
      this.lastScrollTop = st <= 0 ? 0 : st;
      if (bottomOfElement) {
        this.isLoading = true;
        this.$emit("bottom-reached");
      }
      if (topOfElement) {
        this.isLoading = true;
        this.$emit("top-reached");
      }
    },
  },
};
</script>
